import * as React from 'react';
import { useSelector } from 'react-redux';

import { FloatingLabel } from 'shared/components/FloatingLabel';
import { selectOfferType, selectRosReestrSelector } from 'shared/selectors';

import { ROS_REESTR_TOOLTIP_TEXT } from './constants';

export function RosReestrLabelContainer() {
  const isRosReestr = useSelector(selectRosReestrSelector);
  const offerType = useSelector(selectOfferType);

  if (!isRosReestr) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="RosReestrLabel"
      labelText="Проверено в Росреестре"
      tooltipTitle={ROS_REESTR_TOOLTIP_TEXT[offerType].title}
      tooltipText={ROS_REESTR_TOOLTIP_TEXT[offerType].description}
      color="decorative-theme-dark"
      backgroundColor="overlay-control-dark"
    />
  );
}
